var render = function render(){var _vm=this,_c=_vm._self._c;return _c('data-table',{attrs:{"headers":_vm.headers,"items":_vm.league,"show-export":"","show-year-filter":"","read-only":"","itemType":"point","sortBy":"points","sort-desc":""},on:{"yearChange":function($event){return _vm.onYearChange($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }